import { fetchWrapper, handleResponse, hcUrlV3, buildOpts } from 'services/RequestService/helpers';

export const getUser = async () => {
  const response = await fetchWrapper(hcUrlV3('/user'), buildOpts());

  return handleResponse(response);
};
